import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import { withStyles } from '@mui/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';

//gambar
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import EditIcon from '@mui/icons-material/Edit';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import MonitorIcon from '@mui/icons-material/Monitor';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgba(108,122,224,255)",
        borderColor: "rgba(108,122,224,255)",
        color: "white"
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "rgba(248,246,255,255)",
            borderColor: "rgba(248,246,255,255)"
        },
    },
}))(TableRow);

function Riwayat_Transaksi(props, ref) {
    //state
    const [proses, setProses] = useState(false);
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [periode1, setPeriode1] = useState(new Date());
    const [periode2, setPeriode2] = useState(new Date());
    const [data_riwayat, setDataRiwayat] = useState([]);
    const [data_metode_bayar, setDataMetodeBayar] = useState([]);
    const [metode_bayar, setMetodeBayar] = useState("");
    const [metode_bayar_sekarang, setMetodeBayarSekarang] = useState("");
    const [nama_metode_bayar_sekarang, setNamaMetodeBayarSekarang] = useState("");
    const [status_ubah, setStatusUbah] = useState("");
    const [id_bayar, setIdBayar] = useState("");
    const [waktu_pesan, setWaktuPesan] = useState("");
    const [nama, setNama] = useState("");
    const [metode, setMetode] = useState("D");
    const [no_meja, setNoMeja] = useState("");
    const [metode_bayar1, setMetodeBayar1] = useState("");
    const [jumlah_bayar1, setJumlahBayar1] = useState("");
    const [metode_bayar2, setMetodeBayar2] = useState("");
    const [jumlah_bayar2, setJumlahBayar2] = useState("");
    const [kasir, setKasir] = useState("");
    const [data_input_pesanan, setDataInputPesanan] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [diskon, setDiskon] = useState(0);
    const [ppn, setPpn] = useState(0);
    const [biaya_lainnya, setBiayaLainnya] = useState(0);
    const [pembulatan, setPembulatan] = useState(0);
    const [grand_total, setGrandTotal] = useState(0);
    const [tampil_dialog, setTampilDialog] = useState(false);
    const [tampil_dialog_ubah, setTampilDialogUbah] = useState(false);
    const [tampil_dialog_hapus, setTampilDialogHapus] = useState(false);
    const [tampil_dialog_pembatalan, setTampilDialogPembatalan] = useState(false);

    //fungsi    
    useEffect(() => {
        fetch(props.aplikasi + '/metode_bayar/tampil_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: "ada"
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataMetodeBayar(data.data);
                }
                else {
                    setDataMetodeBayar([]);
                }
            })
            .catch(error => {
                setDataMetodeBayar([]);
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }, [props.aplikasi]);

    const format_rupiah = (angka) => {
        return (
            angka
                .toFixed(0)
                .replace(".", ",")
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        )
    }

    const format_tanggal = (waktu, format) => {
        let tahun = waktu.substring(0, 4);
        let bulan = waktu.substring(5, 7);
        let tanggal = waktu.substring(8, 10);
        let jam = waktu.substring(11, 13);
        let menit = waktu.substring(14, 16);
        let detik = waktu.substring(17, 19);

        if (format === "short") {
            return tanggal + "-" + bulan + "-" + tahun;
        }
        else {
            return tanggal + "-" + bulan + "-" + tahun + " " + jam + ":" + menit + ":" + detik;
        }
    }

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const tampil_data_riwayat = () => {
        let tahun = String(periode1.getFullYear());
        let bulan = String(periode1.getMonth() + 1);
        if (bulan.length === 1) {
            bulan = "0" + bulan;
        }
        let tanggal = String(periode1.getDate());
        if (tanggal.length === 1) {
            tanggal = "0" + tanggal;
        }

        let format_periode1 = tahun + "-" + bulan + "-" + tanggal;

        tahun = String(periode2.getFullYear());
        bulan = String(periode2.getMonth() + 1);
        if (bulan.length === 1) {
            bulan = "0" + bulan;
        }
        tanggal = String(periode2.getDate());
        if (tanggal.length === 1) {
            tanggal = "0" + tanggal;
        }

        let format_periode2 = tahun + "-" + bulan + "-" + tanggal;

        setProses(true);
        fetch(props.aplikasi + '/kasir/tampil_riwayat.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pengguna: localStorage.getItem("id_pengguna"),
                        periode1: format_periode1,
                        periode2: format_periode2
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataRiwayat(data.data);
                }
                else {
                    setDataRiwayat([]);
                }
                setProses(false);
            })
            .catch(error => {
                setDataRiwayat([]);
                setProses(false);
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }    

    const tampil_pesanan_detail = (id_pembayaran) => {
        fetch(props.aplikasi + '/kasir/tampil_pesanan_detail_per_id_pesanan.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pembayaran: id_pembayaran
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataInputPesanan(data.data);
                }
                else {
                    setDataInputPesanan([]);
                }
            })
            .catch(error => {
                setDataInputPesanan([]);
            }
            );
    }

    const switch_metode = (param) => {
        switch (param) {
            case "D":
                return "Dine-In";
            case "T":
                return "Take Away";
            default:
                break;
        }
    }

    const switch_warna_metode = (param) => {
        switch (param) {
            case "D":
                return "#e3855f";
            case "T":
                return "#de88e0";
            default:
                break;
        }
    }

    const switch_status_ubah = (param) => {
        switch (param) {
            case "N":
                return "Tidak Ada Permintaan";
            case "R":
                return "Menunggu Diterima";
            case "A":
                return "Diterima";
            case "D":
                return "Ditolak";
            default:
                break;
        }
    }

    const switch_warna_status_ubah = (param) => {
        switch (param) {
            case "N":
                return "red";
            case "R":
                return "gold";
            case "A":
                return "green";
            case "D":
                return "brown";
            default:
                break;
        }
    }

    const simpan = () => {
        if (metode_bayar.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Metode bayar wajib diisi");
            setTampilNotif(true);
            document.getElementById("metode_bayar").focus();
            return;
        }

        fetch(props.aplikasi + '/kasir/simpan_ubah_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pembayaran: id_bayar,
                        metode_sekarang: metode_bayar_sekarang,
                        metode_baru: metode_bayar,
                        id_pengguna: localStorage.getItem("id_pengguna")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setStatusUbah("R");
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    const hapus = () => {
        fetch(props.aplikasi + '/kasir/hapus_permintaan_ubah.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pembayaran: id_bayar
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setTampilDialogUbah(false);
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    const simpan_pembatalan = () => {
        fetch(props.aplikasi + '/kasir/simpan_pembatalan.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pembayaran: id_bayar,
                        id_pengguna: localStorage.getItem("id_pengguna")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                    height: "100%"
                }}
            >
                <Card
                    sx={{ margin: "10px", padding: "10px" }}
                >
                    <Grid container spacing={1}>
                        <Grid container item xs={12}>
                            <Grid item xs={12} sm={4} md={3} lg={2} xl={1}>
                                <Typography variant="body2">
                                    Tanggal Transaksi
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={8} md={9} lg={10} xl={11}>
                                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }} useFlexGap>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            inputFormat="dd-MM-yyyy"
                                            value={periode1}
                                            onChange={(newValue) => {
                                                setPeriode1(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} size="small" />}
                                        />
                                    </LocalizationProvider>

                                    <Typography variant="body2">
                                        s/d
                                    </Typography>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            inputFormat="dd-MM-yyyy"
                                            value={periode2}
                                            onChange={(newValue) => {
                                                setPeriode2(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} size="small" />}
                                        />
                                    </LocalizationProvider>

                                    <LoadingButton
                                        loadingPosition="start"
                                        loading={proses}
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<MonitorIcon />}
                                        sx={{ borderRadius: "5em", backgroundColor: "green" }}
                                        onClick={() =>
                                            tampil_data_riwayat()
                                        }
                                    >
                                        Tampilkan
                                    </LoadingButton>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>

                <Grid container spacing={1} sx={{ padding: "10px" }}>
                    {data_riwayat.map((data_riwayat) => {
                        return (
                            <Grid
                                item xs={12} sm={6} md={4} lg={3} xl={2}
                                key={data_riwayat.id_pesanan}
                                onClick={() => {
                                    setIdBayar(data_riwayat.id_pembayaran);
                                    setWaktuPesan(data_riwayat.waktu_pesan);
                                    setNama(data_riwayat.nama_booking);
                                    setMetode(data_riwayat.metode);
                                    setNoMeja(data_riwayat.no_meja);
                                    setMetodeBayar1(data_riwayat.metode_bayar);
                                    setJumlahBayar1(data_riwayat.jumlah_bayar);
                                    setMetodeBayar2(data_riwayat.metode_bayar2);
                                    setJumlahBayar2(data_riwayat.jumlah_bayar2);
                                    setSubtotal(data_riwayat.subtotal);
                                    setDiskon(data_riwayat.diskon);
                                    setPpn(data_riwayat.ppn);
                                    setBiayaLainnya(data_riwayat.biaya_lainnya);
                                    setPembulatan(data_riwayat.pembulatan);
                                    setGrandTotal(data_riwayat.grand_total);
                                    setKasir(data_riwayat.kasir);
                                    tampil_pesanan_detail(data_riwayat.id_pembayaran);
                                    setTampilDialog(true);
                                }}
                            >
                                <Card sx={{ backgroundColor: "#66615b", color: "white" }}>
                                    <List>
                                        <ListItem button>
                                            <ListItemAvatar>
                                                <Avatar
                                                    sx={{
                                                        backgroundColor: switch_warna_metode(data_riwayat.metode)
                                                    }}
                                                >
                                                    {data_riwayat.no_meja !== "" ? data_riwayat.no_meja : null}
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={<Typography noWrap variant="subtitle1">{data_riwayat.nama_booking}</Typography>}
                                                secondary={
                                                    <div>
                                                        <Typography noWrap variant="body2" color="white">
                                                            {switch_metode(data_riwayat.metode)}
                                                        </Typography>
                                                        <Typography noWrap variant="body2" color="white">
                                                            {format_tanggal(data_riwayat.waktu_pembayaran)}
                                                        </Typography>
                                                    </div>
                                                }
                                            >
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>

            <Dialog
                fullScreen
                open={tampil_dialog}
            >
                <Box>
                    <AppBar
                        sx={{
                            display: 'flex'
                        }}
                    >
                        <Toolbar
                            sx={{ backgroundColor: "#fe9400" }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setTampilDialog(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Detail Pesanan
                            </Typography>

                        </Toolbar>
                    </AppBar>

                    <Grid container spacing={1}
                        sx={{
                            marginTop: "64px"
                        }}
                    >
                        <Grid item xs={12}>
                            <Grid container spacing={1}
                                sx={{
                                    padding: "10px"
                                }}
                            >
                                <Grid item xs={12}>
                                    <Card sx={{ padding: "10px" }}>
                                        <Typography variant="h6">
                                            Data Pemesan
                                        </Typography>

                                        <Divider />
                                        <br />

                                        <Grid container spacing={1}>
                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        No. Bukti
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {id_bayar}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        Waktu Transaksi
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {format_tanggal(waktu_pesan)}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        Nama
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {nama}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        Metode
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {switch_metode(metode)}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        No. Meja
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {no_meja}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        Metode Bayar 1
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {metode_bayar1} (Rp. {format_rupiah(parseFloat(jumlah_bayar1))})
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        Metode Bayar 2
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {metode_bayar2} (Rp. {format_rupiah(parseFloat(jumlah_bayar2))})
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3} md={2} lg={1}>
                                                    <Typography variant="body2">
                                                        Kasir
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            : {kasir}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }} useFlexGap>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<PrintIcon />}
                                                    sx={{ borderRadius: "5em", backgroundColor: "#8080FF" }}
                                                    onClick={() =>
                                                        window.open(props.aplikasi + '/kasir/cetak_pembayaran.php?id_bayar=' + id_bayar)
                                                    }
                                                >
                                                    Cetak
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<EditIcon />}
                                                    sx={{ borderRadius: "5em", backgroundColor: "tomato" }}
                                                    onClick={() => {
                                                        fetch(props.aplikasi + '/kasir/tampil_ubah_metode_bayar.php',
                                                            {
                                                                method: 'POST',
                                                                body: JSON.stringify
                                                                    ({
                                                                        id_pembayaran: id_bayar
                                                                    }),
                                                                headers:
                                                                {
                                                                    "Content-type": "application/json; charset=UTF-8"
                                                                }
                                                            })
                                                            .then(response => response.json())
                                                            .then(data => {
                                                                if (data.kode === 1) {
                                                                    setMetodeBayarSekarang(data.data[0].metode_bayar);
                                                                    setNamaMetodeBayarSekarang(data.data[0].nama_metode_bayar);
                                                                    setMetodeBayar(data.data[0].metode_baru);
                                                                    setStatusUbah(data.data[0].status_ubah);
                                                                }
                                                                else {
                                                                    setMetodeBayarSekarang("");
                                                                    setNamaMetodeBayarSekarang("");
                                                                    setMetodeBayar("");
                                                                    setStatusUbah("N");
                                                                }
                                                            })
                                                            .catch(error => {
                                                                setMetodeBayarSekarang("");
                                                                setNamaMetodeBayarSekarang("");
                                                                setMetodeBayar("");
                                                                setStatusUbah("N");
                                                            }
                                                            );

                                                        setTampilDialogUbah(true);
                                                    }}
                                                >
                                                    Ubah Cara Bayar
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<DeleteIcon />}
                                                    sx={{ borderRadius: "5em", backgroundColor: "red" }}
                                                    onClick={() => {
                                                        setTampilDialogPembatalan(true);
                                                    }}
                                                >
                                                    Ajukan Pembatalan
                                                </Button>
                                            </Stack>

                                            {/* <Grid container spacing={1} item xs={12}>
                                                <Grid item xs={3}>
                                                    <Typography variant="body2">
                                                        Metode Bayar
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2">
                                                            :
                                                        </Typography>

                                                        <Grid container spacing={1}>
                                                            <Grid item xs={12}>
                                                                <FormControl size="small" fullWidth>
                                                                    <Select
                                                                        id="metode_bayar"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        disabled={dp > 0 ? true : false}
                                                                        value={metode_bayar}
                                                                        onChange={(event) => {
                                                                            if (jumlah_metode_bayar === 2) {
                                                                                if (event.target.value === metode_bayar2) {
                                                                                    setJenisNotif("warning");
                                                                                    setIsiNotif("Metode bayar harus berbeda");
                                                                                    setTampilNotif(true);
                                                                                    return;
                                                                                }

                                                                                var awal = 1;
                                                                                var akhir = data_metode_bayar.length;
                                                                                while (awal <= akhir) {
                                                                                    if (data_metode_bayar[awal - 1]["id_metode"] === event.target.value) {
                                                                                        if (parseFloat(data_metode_bayar[awal - 1]["tambah_hpp"]) > 0 || parseFloat(data_metode_bayar[awal - 1]["tambah_jual"]) > 0) {
                                                                                            setJenisNotif("warning");
                                                                                            setIsiNotif("Tidak dapat menambah metode bayar karena terdapat metode bayar dengan penambahan nilai jual");
                                                                                            setTampilNotif(true);
                                                                                            return;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    awal++;
                                                                                }
                                                                            }

                                                                            awal = 1;
                                                                            akhir = data_metode_bayar.length;
                                                                            while (awal <= akhir) {
                                                                                if (event.target.value === data_metode_bayar[awal - 1].id_metode) {
                                                                                    setTambahJual(data_metode_bayar[awal - 1].tambah_jual);
                                                                                    break;
                                                                                }
                                                                                awal++;
                                                                            }

                                                                            setMetodeBayar(event.target.value);
                                                                        }}
                                                                    >
                                                                        {data_metode_bayar.map((data_metode_bayar) => {
                                                                            return (
                                                                                <MenuItem key={data_metode_bayar.id_metode} value={data_metode_bayar.id_metode}>{data_metode_bayar.nama}</MenuItem>
                                                                            )
                                                                        })}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Link
                                                                    component="button"
                                                                    display={jumlah_metode_bayar === 1 ? "" : "none"}
                                                                    onClick={() => {
                                                                        var awal = 1;
                                                                        var akhir = data_metode_bayar.length;
                                                                        while (awal <= akhir) {
                                                                            if (data_metode_bayar[awal - 1]["id_metode"] === metode_bayar) {
                                                                                if (parseFloat(data_metode_bayar[awal - 1]["tambah_hpp"]) > 0 || parseFloat(data_metode_bayar[awal - 1]["tambah_jual"]) > 0) {
                                                                                    setJenisNotif("warning");
                                                                                    setIsiNotif("Tidak dapat menambah metode bayar karena terdapat metode bayar dengan penambahan nilai jual");
                                                                                    setTampilNotif(true);
                                                                                    return;
                                                                                }
                                                                                break;
                                                                            }
                                                                            awal++;
                                                                        }

                                                                        if (jumlah_metode_bayar === 1) {
                                                                            setJumlahMetodeBayar(2);
                                                                        }
                                                                        else {
                                                                            setJumlahMetodeBayar(1);
                                                                        }
                                                                    }}
                                                                >
                                                                    Tambah metode bayar
                                                                </Link>
                                                            </Grid>

                                                            <Grid item xs={12} display={jumlah_metode_bayar === 1 ? "none" : ""}>
                                                                <FormControl size="small" fullWidth>
                                                                    <Select
                                                                        id="metode_bayar2"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        value={metode_bayar2}
                                                                        onChange={(event) => {
                                                                            if (event.target.value === metode_bayar) {
                                                                                setJenisNotif("warning");
                                                                                setIsiNotif("Metode bayar harus berbeda");
                                                                                setTampilNotif(true);
                                                                                return;
                                                                            }

                                                                            var awal = 1;
                                                                            var akhir = data_metode_bayar.length;
                                                                            while (awal <= akhir) {
                                                                                if (data_metode_bayar[awal - 1]["id_metode"] === event.target.value) {
                                                                                    if (parseFloat(data_metode_bayar[awal - 1]["tambah_hpp"]) > 0 || parseFloat(data_metode_bayar[awal - 1]["tambah_jual"]) > 0) {
                                                                                        setJenisNotif("warning");
                                                                                        setIsiNotif("Tidak dapat menambah metode bayar karena terdapat metode bayar dengan penambahan nilai jual");
                                                                                        setTampilNotif(true);
                                                                                        return;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                awal++;
                                                                            }

                                                                            setMetodeBayar2(event.target.value);
                                                                        }}
                                                                    >
                                                                        <MenuItem value="">Pilih Metode Bayar Kedua</MenuItem>
                                                                        {data_metode_bayar.map((data_metode_bayar) => {
                                                                            return (
                                                                                <MenuItem key={data_metode_bayar.id_metode} value={data_metode_bayar.id_metode}>{data_metode_bayar.nama}</MenuItem>
                                                                            )
                                                                        })}
                                                                    </Select>
                                                                </FormControl>

                                                                <Link
                                                                    component="button"
                                                                    display={jumlah_metode_bayar === 1 ? "none" : ""}
                                                                    onClick={() => {
                                                                        if (jumlah_metode_bayar === 1) {
                                                                            setJumlahMetodeBayar(2);
                                                                        }
                                                                        else {
                                                                            setJumlahMetodeBayar(1);
                                                                        }

                                                                        setMetodeBayar2("");
                                                                    }}
                                                                >
                                                                    Hapus metode bayar
                                                                </Link>
                                                            </Grid>
                                                        </Grid>
                                                    </Stack>
                                                </Grid>
                                            </Grid> */}
                                        </Grid>
                                    </Card>
                                </Grid>

                                <Grid item xs={12}>
                                    <Card sx={{ padding: "10px" }}>
                                        <Typography variant="h6">
                                            Daftar Pesanan
                                        </Typography>

                                        <Divider />
                                        <br />

                                        <TableContainer component={Paper}>
                                            <Table stickyHeader size="small" aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell align="center">Nama</StyledTableCell>
                                                        <StyledTableCell align="center">Harga</StyledTableCell>
                                                        <StyledTableCell align="center">Diskon</StyledTableCell>
                                                        <StyledTableCell align="center">Jumlah</StyledTableCell>
                                                        <StyledTableCell align="center">Subtotal</StyledTableCell>
                                                        <StyledTableCell align="center">Catatan</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data_input_pesanan.map((data_input_pesanan, index) => {
                                                        return (
                                                            <StyledTableRow key={data_input_pesanan.id_produk}>
                                                                <TableCell size="small"><Typography variant="body2" noWrap={true}>{data_input_pesanan.nama}</Typography></TableCell>
                                                                <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{format_rupiah(parseFloat(data_input_pesanan.harga) + parseFloat(data_input_pesanan.diskon_nominal))}</Typography></TableCell>
                                                                <TableCell size="small" align="right"><Typography variant="body2" noWrap={true} sx={{ color: "green" }}>{parseFloat(data_input_pesanan.diskon_nominal) !== 0 ? "-" : ""} {format_rupiah(parseFloat(data_input_pesanan.diskon_nominal))}</Typography></TableCell>
                                                                <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_input_pesanan.jumlah}</Typography></TableCell>
                                                                <TableCell size="small" align="right">
                                                                    <Typography variant="body2" noWrap={true}>
                                                                        {format_rupiah(parseFloat(data_input_pesanan.jumlah) * parseFloat(data_input_pesanan.harga))}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell size="small">
                                                                    <Typography variant="body2" noWrap={true}>{data_input_pesanan.catatan}</Typography>
                                                                </TableCell>
                                                            </StyledTableRow>
                                                        );
                                                    })}

                                                    <TableRow>
                                                        <TableCell align="right" colSpan={4}>
                                                            <Typography variant="h6">
                                                                Subtotal
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                                {/* {format_rupiah(parseFloat(hitung_total()))} */}
                                                                {format_rupiah(parseFloat(subtotal))}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right" colSpan={4}>
                                                            <Typography variant="h6">
                                                                Diskon
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                                {format_rupiah(parseFloat(diskon))}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right" colSpan={4}>
                                                            <Typography variant="h6">
                                                                PPN
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                                {format_rupiah(parseFloat(ppn))}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right" colSpan={4}>
                                                            <Typography variant="h6">
                                                                Biaya Lainnya
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                                {format_rupiah(parseFloat(biaya_lainnya))}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right" colSpan={4}>
                                                            <Typography variant="h6">
                                                                Pembulatan
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                                {format_rupiah(parseFloat(pembulatan))}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right" colSpan={4}>
                                                            <Typography variant="h6">
                                                                Grand Total
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                                {/* {format_rupiah(parseFloat(hitung_total()) - parseFloat(diskon))} */}
                                                                {format_rupiah(parseFloat(grand_total))}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell />
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Dialog>

            <Dialog
                open={tampil_dialog_ubah}
                onClose={() => setTampilDialogUbah(false)}
            >
                <DialogTitle>Permintaan Pengubahan Metode Bayar</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Metode Saat Ini
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <Typography variant="body2">
                                        {nama_metode_bayar_sekarang}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Menjadi
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            id="metode_bayar"
                                            variant="outlined"
                                            fullWidth
                                            value={metode_bayar}
                                            onChange={(event) => {
                                                setMetodeBayar(event.target.value);
                                            }}
                                        >
                                            {data_metode_bayar.map((data_metode_bayar) => {
                                                return (
                                                    <MenuItem key={data_metode_bayar.id_metode} value={data_metode_bayar.id_metode}>{data_metode_bayar.nama}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Status Permintaan
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <Typography variant="body2"
                                        sx={{
                                            color: switch_warna_status_ubah(status_ubah)
                                        }}
                                    >
                                        {switch_status_ubah(status_ubah)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SaveOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em" }}
                        onClick={() => simpan()}
                    >
                        <Typography variant="body2" noWrap={true}>Simpan</Typography>
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "red" }}
                        onClick={() => setTampilDialogHapus(true)}
                    >
                        <Typography variant="body2" noWrap={true}>Hapus</Typography>
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CloseOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        onClick={() => setTampilDialogUbah(false)}
                    >
                        <Typography variant="body2" noWrap={true}>Tutup</Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_hapus}
                onClose={() => setTampilDialogHapus(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Hapus Permintaan
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin menghapus data ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTampilDialogHapus(false)} autoFocus>Tidak</Button>
                    <Button
                        onClick={() => {
                            hapus();
                            setTampilDialogHapus(false);
                        }}
                    >Ya</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_pembatalan}
                onClose={() => setTampilDialogPembatalan(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Pembatalan Transaksi
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin membatalkan transaksi ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTampilDialogPembatalan(false)} autoFocus>Tidak</Button>
                    <Button
                        onClick={() => {
                            simpan_pembatalan();
                            setTampilDialogPembatalan(false);
                        }}
                    >Ya</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default forwardRef(Riwayat_Transaksi);